<!-- eslint-disable max-len -->
<template>
  <svg
    width="100"
    height="22"
    viewBox="0 0 100 22"
    fill="#6e6e72"
    class="icons-svg"
  >
    <path
      d="M49.815 11c0 6.066 5.002 11 11.15 11 6.148 0 11.15-4.934 11.15-11 0-6.064-5.002-10.999-11.15-10.999-6.148 0-11.15 4.935-11.15 11zm5.261 0c0-3.203 2.642-5.809 5.89-5.809 3.246 0 5.888 2.606 5.888 5.81 0 3.203-2.642 5.809-5.889 5.809-3.247 0-5.889-2.606-5.889-5.81zM74.769 12.447c0 3.318 1.31 6.44 3.69 8.792a2.641 2.641 0 001.862.76c.672 0 1.345-.252 1.859-.758a2.57 2.57 0 00.002-3.67 7.158 7.158 0 01-2.152-5.124c0-4.001 3.3-7.256 7.355-7.256 4.055 0 7.354 3.255 7.354 7.256a7.16 7.16 0 01-2.152 5.125 2.57 2.57 0 00.003 3.67 2.656 2.656 0 003.72-.004c2.38-2.35 3.69-5.473 3.69-8.791C100 5.584 94.34 0 87.385 0c-6.957 0-12.616 5.583-12.616 12.446zM0 12.447c0 3.318 1.31 6.44 3.69 8.792a2.657 2.657 0 003.72.002 2.57 2.57 0 00.003-3.67 7.158 7.158 0 01-2.152-5.124c0-4.001 3.3-7.256 7.355-7.256 4.055 0 7.355 3.255 7.355 7.256a7.159 7.159 0 01-2.153 5.125 2.57 2.57 0 00.003 3.67A2.642 2.642 0 0019.68 22a2.64 2.64 0 001.86-.761c2.38-2.351 3.691-5.474 3.691-8.792C25.231 5.584 19.571 0 12.616 0 5.659.001 0 5.584 0 12.447zM27.997 11c0 6.064 5.002 10.999 11.15 10.999a11.18 11.18 0 007.71-3.058 2.57 2.57 0 00.08-3.669 2.655 2.655 0 00-3.718-.079 5.904 5.904 0 01-4.072 1.616c-3.247 0-5.89-2.606-5.89-5.81 0-3.203 2.643-5.81 5.89-5.81 1.523 0 2.969.575 4.072 1.616a2.655 2.655 0 003.718-.079 2.57 2.57 0 00-.08-3.669A11.18 11.18 0 0039.148 0c-6.148 0-11.15 4.934-11.15 11z"
      fill="#6e6e72"
    ></path>
    <path
      d="M36.518 11c0 1.432 1.177 2.593 2.628 2.593 1.452 0 2.629-1.161 2.629-2.593s-1.177-2.593-2.629-2.593c-1.451 0-2.628 1.161-2.628 2.593z"
      fill="#6e6e72"
    ></path>
  </svg>
</template>

<script>
export default {
  name: 'Neon',
};
</script>
